import { render, staticRenderFns } from "./yglb.vue?vue&type=template&id=3efc3004&scoped=true&"
import script from "./yglb.vue?vue&type=script&lang=js&"
export * from "./yglb.vue?vue&type=script&lang=js&"
import style0 from "./yglb.vue?vue&type=style&index=0&id=3efc3004&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efc3004",
  null
  
)

export default component.exports